export default {
  meta_title: 'Page not found | PennyLane',
  meta_description: '',
  meta_image:
    'https://assets.cloud.pennylane.ai/pennylane_website/generic/generic_og.png',
}
